import { render, staticRenderFns } from "./fuel-corrections.vue?vue&type=template&id=60a2fda0&"
import script from "./fuel-corrections.vue?vue&type=script&lang=ts&"
export * from "./fuel-corrections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports